import dynamic from 'next/dynamic';
import { ArabicFormLanguageSelectionProps } from './ArabicFormLanguageSelection.types';

export const ArabicFormLanguageSelection = dynamic<ArabicFormLanguageSelectionProps>(() =>
  import('./ArabicFormLanguageSelection').then(module => module.ArabicFormLanguageSelection)
);
